import Modal from './modal';
import './styles/index.scss';
export default Modal;
